var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonthlySmoothBillingDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.80002 31.9999C4.80002 31.9999 7.90002 29.0999 9.40002 31.9999C9.40002 31.9999 9.90002 80.8999 9.70002 89.0999C9.70002 89.0999 6.70002 90.4999 5.00002 89.0999C5.00002 89.0999 4.50002 39.0999 4.80002 31.9999Z",
    fill: "#004745",
    stroke: "#004745",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6 31.9999C12.6 31.9999 15.7 29.0999 17.2 31.9999C17.2 31.9999 17.7 80.8999 17.4 89.0999C17.4 89.0999 14.5 90.4999 12.7 89.0999C12.7 89.0999 12.3 39.0999 12.6 31.9999Z",
    fill: "#004745",
    stroke: "#004745",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3 31.9999C20.3 31.9999 23.5 29.0999 25 31.9999C25 31.9999 25.4 80.8999 25.2 89.0999C25.2 89.0999 22.3 90.4999 20.5 89.0999C20.5 89.0999 20.1 39.0999 20.3 31.9999Z",
    fill: "#004745",
    stroke: "#004745",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1 31.9999C28.1 31.9999 31.3 29.0999 32.8 31.9999C32.8 31.9999 33.2 80.8999 33 89.0999C33 89.0999 30.1 90.4999 28.3 89.0999C28.3 89.0999 27.9 39.0999 28.1 31.9999Z",
    fill: "#004745",
    stroke: "#004745",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9 31.9999C35.9 31.9999 39 29.0999 40.5 31.9999C40.5 31.9999 41 80.8999 40.8 89.0999C40.8 89.0999 37.9 90.4999 36.1 89.0999C36.1 89.0999 35.7 39.0999 35.9 31.9999Z",
    fill: "#004745",
    stroke: "#004745",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7 31.9999C43.7 31.9999 46.8 29.0999 48.3 31.9999C48.3 31.9999 48.8 80.8999 48.6 89.0999C48.6 89.0999 45.6 90.4999 43.9 89.0999C43.9 89.0999 43.4 39.0999 43.7 31.9999Z",
    fill: "#004745",
    stroke: "#004745",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67 31.9999C67 31.9999 70.2 29.0999 71.7 31.9999C71.7 31.9999 72.1 80.8999 71.9 89.0999C71.9 89.0999 69 90.4999 67.2 89.0999C67.2 89.0999 66.8 39.0999 67 31.9999Z",
    fill: "#004745",
    stroke: "#004745",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8 31.9999C74.8 31.9999 77.9 29.0999 79.4 31.9999C79.4 31.9999 79.9 80.8999 79.7 89.0999C79.7 89.0999 76.8 90.4999 75 89.0999C75 89.0999 74.6 39.0999 74.8 31.9999Z",
    fill: "#004745",
    stroke: "#004745",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6 31.9999C82.6 31.9999 85.7 29.0999 87.2 31.9999C87.2 31.9999 87.7 80.8999 87.5 89.0999C87.5 89.0999 84.5 90.4999 82.8 89.0999C82.8 89.0999 82.3 39.0999 82.6 31.9999Z",
    fill: "#004745",
    stroke: "#004745",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4 31.9999C90.4 31.9999 93.5 29.0999 95 31.9999C95 31.9999 95.5 80.8999 95.2 89.0999C95.2 89.0999 92.3 90.4999 90.5 89.0999C90.5 89.0999 90.1 39.0999 90.4 31.9999Z",
    fill: "#004745",
    stroke: "#004745",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5 31.9999C51.5 31.9999 54.6 29.0999 56.1 31.9999C56.1 31.9999 56.6 80.8999 56.3 89.0999C56.3 89.0999 53.4 90.4999 51.6 89.0999C51.6 89.0999 51.2 39.0999 51.5 31.9999Z",
    fill: "#004745",
    stroke: "#004745",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2 31.9999C59.2 31.9999 62.4 29.0999 63.9 31.9999C63.9 31.9999 64.3 80.8999 64.1 89.0999C64.1 89.0999 61.2 90.4999 59.4 89.0999C59.4 89.0999 59 39.0999 59.2 31.9999Z",
    fill: "#004745",
    stroke: "#004745",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M5.89998 95.7H5.59998V95.2H6.29998C6.39499 95.0519 6.43069 94.8734 6.39998 94.7V92.8H6.99998V94.7C7.01208 94.8325 6.991 94.9658 6.93862 95.088C6.88624 95.2103 6.80422 95.3175 6.69998 95.4C6.64122 95.5041 6.55272 95.5883 6.44582 95.6417C6.33892 95.6952 6.21849 95.7155 6.09998 95.7H5.89998Z",
    fill: "#004745"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5 95.7H45.3V95.2C45.3 95.2266 45.3105 95.252 45.3293 95.2708C45.348 95.2895 45.3735 95.3 45.4 95.3H45.6C45.8 95.3 45.9 95.3 45.9 95.2C45.995 95.0519 46.0307 94.8734 46 94.7V92.8H46.6V94.7C46.6121 94.8325 46.591 94.9658 46.5386 95.088C46.4862 95.2103 46.4042 95.3175 46.3 95.4C46.2412 95.5041 46.1527 95.5883 46.0458 95.6417C45.9389 95.6952 45.8185 95.7155 45.7 95.7H45.5Z",
    fill: "#004745"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4 95.7H53.2V95.2C53.2 95.3 53.3 95.3 53.4 95.3H54C54.0432 95.1355 54.0766 94.9685 54.1 94.8V92.8H54.6V94.7C54.6074 94.9485 54.5376 95.1931 54.4 95.4C54.3124 95.4982 54.2043 95.5759 54.0833 95.6277C53.9624 95.6796 53.8315 95.7042 53.7 95.7H53.4Z",
    fill: "#004745"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4 92.8H15.1V93.3H14V94H15.1V94.5H14V95.7H13.4V92.8Z",
    fill: "#004745"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8 92.8H21.5L22.2 94.4L22.9 92.8H23.6L23.8 95.7H23.2V93.5L22.4 95H21.9L21.2 93.5V95.7H20.7L20.8 92.8Z",
    fill: "#004745"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3 95.7H28.8L29.8 92.8H30.4L31.5 95.7H30.9L30.7 95H29.5L29.3 95.7ZM29.7 94.6H30.5L30.1 93.4L29.7 94.6Z",
    fill: "#004745"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M61 95.7H60.5L61.5 92.8H62.1L63.2 95.7H62.6L62.4 95H61.2L61 95.7ZM61.4 94.6H62.2L61.8 93.4L61.4 94.6Z",
    fill: "#004745"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5 93.3C69.4638 93.3405 69.4363 93.3881 69.4191 93.4397C69.4019 93.4912 69.3954 93.5458 69.4 93.6C69.4 93.7 69.4 93.7 69.5 93.8L69.9 94H70.3C70.3 94.1 70.4 94.1 70.5 94.2L70.7 94.4V94.7C70.7 94.9 70.7 95 70.6 95.1L70.4 95.4L70.1 95.6H69.2L68.7 95.4L69 95L69.3 95.2H69.7C70 95.2 70.2 95.1 70.2 94.9C70.2 94.7 70.2 94.8 70.1 94.7H69.3C69.247 94.7 69.1961 94.6789 69.1586 94.6414C69.1211 94.6039 69.1 94.553 69.1 94.5L68.9 94.3C68.9 94.2 68.8 94.1 68.8 94C68.8 93.9 68.9 93.8 68.9 93.7L69.1 93.4L69.4 93.2H70.3L70.7 93.6L70.2 93.8C70.1422 93.7487 70.1063 93.677 70.1 93.6H69.5V93.3Z",
    fill: "#004745"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3 93.7C76.3418 93.5047 76.4473 93.3288 76.6 93.2L77.1 92.9H78.2L78.7 93.2C78.796 93.2415 78.8766 93.3121 78.9304 93.4018C78.9843 93.4915 79.0086 93.5958 79 93.7C79.1225 93.8386 79.1931 94.0152 79.2 94.2C79.2092 94.3084 79.1962 94.4175 79.1618 94.5206C79.1274 94.6238 79.0724 94.7189 79 94.8C79.0086 94.9043 78.9843 95.0086 78.9304 95.0983C78.8766 95.188 78.796 95.2585 78.7 95.3L78.2 95.6H77.1L76.6 95.3L76.3 94.8C76.205 94.6519 76.1693 94.4733 76.2 94.3C76.2 94 76.2 93.8 76.3 93.7ZM76.8 94.6C76.8 94.8 76.9 94.9 77 94.9L77.3 95.1H78L78.3 94.9C78.4 94.9 78.5 94.8 78.5 94.6C78.5362 94.5594 78.5637 94.5119 78.5809 94.4603C78.5981 94.4087 78.6046 94.3542 78.6 94.3C78.6 94.1 78.6 94 78.5 93.9C78.4 93.8 78.4 93.7 78.3 93.6L78 93.4H77.3L77 93.6C76.9 93.7 76.8 93.8 76.8 93.9C76.8 94 76.7 94.1 76.7 94.3C76.6954 94.3542 76.7019 94.4087 76.7191 94.4603C76.7363 94.5119 76.7638 94.5594 76.8 94.6Z",
    fill: "#004745"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4 92.8H84.9L86.3 94.8V92.8H86.8V95.7H86.3L84.9 93.7V95.7H84.4V92.8Z",
    fill: "#004745"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3 92.8H93.9L94.3 93.1C94.4845 93.2184 94.6251 93.394 94.7 93.6C94.7432 93.7646 94.7766 93.9315 94.8 94.1C94.8 94.3 94.7 94.5 94.7 94.7L94.3 95.2L93.9 95.5H92.2V92.8H93.3ZM93.6 95.1L93.9 94.9C94 94.9 94.1 94.8 94.1 94.6C94.1 94.4 94.2 94.4 94.2 94.2C94.2022 94.0603 94.1677 93.9224 94.1 93.8L93.9 93.5H92.8V95.4H93.6V95.1Z",
    fill: "#004745"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6 92.8H37.3L38 94.4L38.8 92.8H39.5V95.7H39V93.5L38.3 95H37.8L37.1 93.5V95.7H36.6V92.8Z",
    fill: "#004745"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonthlySmoothBillingDisabled);
export default __webpack_public_path__ + "static/media/monthly-smooth-billing-disabled.29df90100466d906c916020cd3adb4c5.svg";
export { ForwardRef as ReactComponent };